/**
 * Desktop (and large screens): click image sides / arrows to change product photos.
 * Works with Dawn thumbnail gallery (single active image).
 */
(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 750px)');

  function initGallery(gallery) {
    if (gallery.dataset.xasNavInit === 'true') return;

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    const items = () => [...viewer.querySelectorAll('.product__media-item')];
    if (items().length < 2) return;

    gallery.dataset.xasNavInit = 'true';

    const nav = document.createElement('div');
    nav.className = 'xas-gallery-nav';
    nav.innerHTML = `
      <button type="button" class="xas-gallery-nav__btn xas-gallery-nav__btn--prev" aria-label="Previous image">
        <span aria-hidden="true">‹</span>
      </button>
      <button type="button" class="xas-gallery-nav__btn xas-gallery-nav__btn--next" aria-label="Next image">
        <span aria-hidden="true">›</span>
      </button>
      <button type="button" class="xas-gallery-nav__zone xas-gallery-nav__zone--prev" aria-label="Previous image"></button>
      <button type="button" class="xas-gallery-nav__zone xas-gallery-nav__zone--next" aria-label="Next image"></button>
    `;
    viewer.appendChild(nav);

    function activeIndex() {
      const list = items();
      const i = list.findIndex((el) => el.classList.contains('is-active'));
      return i === -1 ? 0 : i;
    }

    function go(delta) {
      const list = items();
      if (list.length < 2) return;
      const nextIndex = (activeIndex() + delta + list.length) % list.length;
      const mediaId = list[nextIndex].dataset.mediaId;
      if (!mediaId) return;

      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
      } else {
        list.forEach((el) => el.classList.remove('is-active'));
        list[nextIndex].classList.add('is-active');
      }
    }

    nav.querySelector('.xas-gallery-nav__btn--prev').addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      go(-1);
    });
    nav.querySelector('.xas-gallery-nav__btn--next').addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      go(1);
    });
    nav.querySelector('.xas-gallery-nav__zone--prev').addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      go(-1);
    });
    nav.querySelector('.xas-gallery-nav__zone--next').addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      go(1);
    });

    // Keyboard support when gallery is focused / hovered
    gallery.addEventListener('keydown', (e) => {
      if (!DESKTOP_MQ.matches) return;
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(-1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(1);
      }
    });
    if (!gallery.hasAttribute('tabindex')) gallery.setAttribute('tabindex', '0');
  }

  function boot() {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  // Defer until after media-gallery.js has upgraded the custom element
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    requestAnimationFrame(boot);
  }

  document.addEventListener('shopify:section:load', boot);
})();
